module.exports = __webpack_public_path__ + "img/logo.c5547f95.png";